/* Veloramode – productpagina: varianten, galerij, winkelmand, maattabel, sticky knop */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var re = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '{{amount}} zł';
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(re);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(re, value);
  }

  function init(el) {
    if (el.__ql) return;
    el.__ql = true;
    var jsonEl = $('[data-ql-product-json]', el);
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var form = $('[data-ql-form]', el) || $('#QlProductForm', el);
    var idInput = $('[data-ql-variant-id]', el);
    var atc = $('[data-ql-atc]', el);
    var atcText = $('[data-ql-atc-text]', el);
    var stock = $('[data-ql-stock]', el);
    var priceEl = $('[data-ql-price]', el);
    var note = $('[data-ql-ref-note]', el);
    var colorName = $('[data-ql-color-name]', el);
    var msg = $('[data-ql-msg]', el);
    var stickybar = $('[data-ql-stickybar]', el);
    var stickyAtc = $('[data-ql-sticky-atc]', el);
    var stickyPrice = $('[data-ql-sticky-price]', el);
    var groups = $$('[data-ql-option]', el);
    var S = data.strings;

    /* ---------- Galerij ---------- */
    var track = $('[data-ql-gallery-track]', el);
    var prog = $('[data-ql-gallery-progress]', el);
    var thumbs = $$('[data-ql-thumb]', el);
    var slides = track ? $$('.ql-gallery__slide', track) : [];
    function current() {
      if (!track || !track.clientWidth) return 0;
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function paint() {
      var i = current();
      if (prog && slides.length) {
        prog.style.width = (100 / slides.length) + '%';
        prog.style.transform = 'translateX(' + (i * 100) + '%)';
      }
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    function goTo(i, smooth) {
      if (!track) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    if (track) {
      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(current() + 1, slides.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(current() - 1, 0)); }
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-ql-thumb'), 10)); });
      });
    }
    function showMedia(mediaId) {
      if (!mediaId || !track) return;
      var s = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (s) goTo(parseInt(s.getAttribute('data-index'), 10));
    }

    /* ---------- Varianten ---------- */
    function selected() {
      var opts = data.options.map(function () { return null; });
      groups.forEach(function (g) {
        var pos = parseInt(g.getAttribute('data-ql-option'), 10) - 1;
        var c = g.querySelector('input:checked');
        opts[pos] = c ? c.value : null;
      });
      // opties zonder keuzegroep (bijv. 'Default Title')
      var first = data.variants[0];
      opts = opts.map(function (v, k) { return v === null && first ? first.options[k] : v; });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      groups.forEach(function (g) {
        var pos = parseInt(g.getAttribute('data-ql-option'), 10) - 1;
        $$('input', g).forEach(function (input) {
          var test = opts.slice();
          test[pos] = input.value;
          var v = findVariant(test);
          var label = input.closest('label');
          if (label) label.classList.toggle('is-unavailable', !(v && v.available));
        });
      });
    }
    function setPrice(v) {
      var html = '';
      if (v.compare > v.price) html += '<s class="ql-muted"><span class="ql-sr">Cena regularna </span>' + formatMoney(v.compare, data.moneyFormat) + '</s>';
      html += '<span>' + formatMoney(v.price, data.moneyFormat) + '</span>';
      if (priceEl) priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price, data.moneyFormat);
      if (note) { if (v.compare > v.price) note.removeAttribute('hidden'); else note.setAttribute('hidden', ''); }
    }
    function setButtons(enabled, text) {
      [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = !enabled; });
      if (atcText) atcText.textContent = text;
      if (stickyAtc) stickyAtc.textContent = text;
    }
    function onChange(e) {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      if (msg) msg.textContent = '';
      if (data.colorIndex !== null && colorName) colorName.textContent = opts[data.colorIndex] || '';
      if (!v) {
        setButtons(false, S.unavailable);
        if (stock) stock.textContent = S.unavailable;
        return;
      }
      if (idInput) idInput.value = v.id;
      setPrice(v);
      setButtons(v.available, v.available ? S.atc : S.soldOut);
      if (stock) stock.textContent = v.available ? S.inStock : S.soldOut;
      var changedColor = e && data.colorIndex !== null && e.target && e.target.closest('[data-ql-option]') &&
        parseInt(e.target.closest('[data-ql-option]').getAttribute('data-ql-option'), 10) - 1 === data.colorIndex;
      if (v.media && (changedColor || data.colorIndex === null)) showMedia(v.media);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (err) {}
      el.dispatchEvent(new CustomEvent('ql:variant', { bubbles: true, detail: { variant: v } }));
    }
    groups.forEach(function (g) { g.addEventListener('change', onChange); });
    markAvailability(selected());

    /* ---------- In winkelmand ---------- */
    function drawerOpen() {
      var d = document.getElementById('CartDrawer');
      var h = document.documentElement.className + ' ' + document.body.className;
      return !!(d && (/is-open|is-active|drawer--is-open|active/.test(d.className) || d.getAttribute('aria-hidden') === 'false')) || /js-drawer-open|drawer-open|cart-open/.test(h);
    }
    function openCart(item) {
      try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: atc } })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:open')); } catch (e) {}
      if (window.qlRefreshCartCount) window.qlRefreshCartCount();
      setTimeout(function () {
        if (drawerOpen()) return;
        var link = document.querySelector('[data-ql-cart-link]') || document.querySelector('.js-drawer-open-cart');
        if (link) link.click(); else window.location.href = root + 'cart';
      }, 450);
    }
    function add(e) {
      if (e) e.preventDefault();
      if (!form || !atc || atc.disabled) return;
      atc.setAttribute('aria-busy', 'true');
      [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = true; });
      var body = new FormData(form);
      fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { if (msg) msg.textContent = res.json.description || res.json.message || S.error; return; }
          if (msg) msg.textContent = S.added;
          openCart(res.json);
        })
        .catch(function () { if (msg) msg.textContent = S.error; })
        .then(function () {
          atc.removeAttribute('aria-busy');
          var v = findVariant(selected());
          [atc, stickyAtc].forEach(function (b) { if (b) b.disabled = !(v && v.available); });
        });
    }
    if (form) form.addEventListener('submit', add);
    if (stickyAtc) stickyAtc.addEventListener('click', add);

    /* ---------- Sticky knop op mobiel ---------- */
    if (stickybar && atc && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 989px)');
      var io = new IntersectionObserver(function (entries) {
        var hidden = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        var on = hidden && mq.matches;
        stickybar.classList.toggle('is-visible', on);
        stickybar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (stickyAtc) stickyAtc.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('ql-sticky-on', on);
      });
      io.observe(atc);
    }

    /* ---------- Maattabel ---------- */
    var dialog = $('[data-ql-chart]', el);
    $$('[data-ql-chart-open]', el).forEach(function (b) {
      b.addEventListener('click', function () {
        if (!dialog) return;
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      });
    });
    if (dialog) {
      $$('[data-ql-chart-close]', dialog).forEach(function (b) { b.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); }); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog && dialog.close) dialog.close(); });
    }

    paint();
  }

  function boot(ctx) { $$('[data-ql-product]', ctx).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }); else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
